module.exports = __webpack_public_path__ + "static/img/doctor_photo.1161778.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctor_photo.jpeg
// module id = pfpV
// module chunks = 7